<template>
  <div class="login">
    <div class="content">
      <h3 style="color: green;">采销中心</h3>

      <!-- Tab 切换 -->
      <el-tabs v-model="activeTab" @tab-click="handleTabClick">
        <!-- 销售端 -->
        <el-tab-pane label="销售端" name="sales">
          <!-- 登录表单 -->
          <el-form
            v-if="!salesRegister"
            :model="loginForm"
            status-icon
            :rules="loginRules"
            ref="loginFormRef"
            class="demo-ruleForm"
          >
            <el-form-item prop="username">
              <el-input
                type="text"
                v-model="loginForm.username"
                prefix-icon="el-icon-user"
                placeholder="请输入手机号"
              />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="loginForm.password"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
              />
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="captcha-wrapper">
                <el-input
                  v-model="loginForm.captcha"
                  prefix-icon="el-icon-key"
                  placeholder="请输入验证码"
                  class="captcha-input"
                />
                <div class="captcha-image" @click="refreshCaptcha">
                  <img :src="captchaUrl" alt="验证码" v-if="captchaUrl" />
                  <span v-else>加载中...</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="user_type">
              <el-radio-group v-model="loginForm.user_type">
                <el-radio label="wholesaler" border size="medium">品牌方</el-radio>
                <el-radio label="retailer" border size="medium">经销商</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="checked">记住我</el-checkbox>
            </el-form-item>
            <el-button type="primary" @click="handleLogin" :loading="loading">登录</el-button>
            <div class="bottom-links">
              <span class="link" @click="toggleRegister">暂未账号？前往注册账号</span>
              <span class="link" @click="forgotPassword">忘记密码</span>
            </div>
          </el-form>

          <!-- 注册表单 -->
          <el-form
            v-else
            :model="registerForm"
            status-icon
            :rules="registerRules"
            ref="registerFormRef"
            class="demo-ruleForm"
          >
            <el-form-item prop="username">
              <el-input
                type="text"
                v-model="registerForm.username"
                prefix-icon="el-icon-user"
                placeholder="请输入手机号"
              />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="registerForm.password"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
              />
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input
                type="password"
                v-model="registerForm.confirmPassword"
                prefix-icon="el-icon-lock"
                placeholder="请再次输入密码"
              />
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="captcha-wrapper">
                <el-input
                  v-model="registerForm.captcha"
                  prefix-icon="el-icon-key"
                  placeholder="请输入验证码"
                  class="captcha-input"
                />
                <div class="captcha-image" @click="refreshCaptcha">
                  <img :src="captchaUrl" alt="验证码" v-if="captchaUrl" />
                  <span v-else>加载中...</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="comname">
              <el-input
                v-model="registerForm.comname"
                prefix-icon="el-icon-office-building"
                placeholder="请输入公司名称"
              />
            </el-form-item>
            <el-form-item prop="comcode">
              <el-input
                v-model="registerForm.comcode"
                prefix-icon="el-icon-document"
                placeholder="请输入统一社会信用代码"
              />
            </el-form-item>
            <el-form-item prop="user_type">
              <el-radio-group v-model="registerForm.user_type">
                <el-radio label="wholesaler" border size="medium">品牌方</el-radio>
                <el-radio label="retailer" border size="medium">经销商</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-button type="primary" @click="handleRegister" :loading="loading">注册</el-button>
            <div class="bottom-links">
              <span class="link" @click="toggleRegister">返回登录</span>
            </div>
          </el-form>
        </el-tab-pane>

        <!-- 采购端 -->
        <el-tab-pane label="采购端" name="purchase">
          <!-- 采购端登录 -->
          <el-form
            v-if="!purchaseIsRegister"
            :model="purchaseLoginForm"
            status-icon
            :rules="purchaseLoginRules"
            ref="purchaseLoginFormRef"
            class="demo-ruleForm"
          >
            <el-form-item prop="username">
              <el-input
                type="text"
                v-model="purchaseLoginForm.username"
                prefix-icon="el-icon-user"
                placeholder="请输入手机号"
              />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="purchaseLoginForm.password"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
              />
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="captcha-wrapper">
                <el-input
                  v-model="purchaseLoginForm.captcha"
                  prefix-icon="el-icon-key"
                  placeholder="请输入验证码"
                  class="captcha-input"
                />
                <div class="captcha-image" @click="refreshCaptcha">
                  <img :src="captchaUrl" alt="验证码" v-if="captchaUrl" />
                  <span v-else>加载中...</span>
                </div>
              </div>
            </el-form-item>
            <el-button type="primary" @click="handlePurchaseLogin" :loading="loading">登录</el-button>
            <div class="bottom-links">
              <span class="link" @click="togglePurchaseRegister">暂未账号？前往注册账号</span>
              <span class="link" @click="forgotPassword">忘记密码</span>
            </div>
          </el-form>

          <!-- 采购端注册 -->
          <el-form
            v-else
            :model="purchaseRegisterForm"
            status-icon
            :rules="purchaseRegisterRules"
            ref="purchaseRegisterFormRef"
            class="demo-ruleForm"
          >
            <el-form-item prop="username">
              <el-input
                type="text"
                v-model="purchaseRegisterForm.username"
                prefix-icon="el-icon-user"
                placeholder="请输入手机号"
              />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="purchaseRegisterForm.password"
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
              />
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input
                type="password"
                v-model="purchaseRegisterForm.confirmPassword"
                prefix-icon="el-icon-lock"
                placeholder="请再次输入密码"
              />
            </el-form-item>
            <el-form-item prop="captcha">
              <div class="captcha-wrapper">
                <el-input
                  v-model="purchaseRegisterForm.captcha"
                  prefix-icon="el-icon-key"
                  placeholder="请输入验证码"
                  class="captcha-input"
                />
                <div class="captcha-image" @click="refreshCaptcha">
                  <img :src="captchaUrl" alt="验证码" v-if="captchaUrl" />
                  <span v-else>加载中...</span>
                </div>
              </div>
            </el-form-item>
            <el-button type="primary" @click="handlePurchaseRegister" :loading="loading">注册</el-button>
            <div class="bottom-links">
              <span class="link" @click="togglePurchaseRegister">返回登录</span>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import axios from 'axios'

const captchaRequest = axios.create({
  withCredentials: true,
  responseType: 'arraybuffer'
})

const apiRequest = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

export default {
  name: 'Login',
  data () {
    // 手机号校验函数
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }
    // 确认密码校验
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password && value !== this.purchaseRegisterForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }

    return {
      // 当前激活的tab
      activeTab: 'sales',

      // ---- 销售端 ----
      salesRegister: false, // 是否显示注册
      loginForm: {
        username: '',
        password: '',
        captcha: '',
        user_type: 'wholesaler'
      },
      registerForm: {
        username: '',
        password: '',
        confirmPassword: '',
        captcha: '',
        comname: '',
        comcode: '',
        user_type: 'wholesaler'
      },
      checked: false,
      loading: false,
      captchaUrl: '',
      serverCaptcha: '',

      // ---- 采购端 ----
      purchaseIsRegister: false,
      purchaseLoginForm: {
        username: '',
        password: '',
        captcha: ''
      },
      purchaseRegisterForm: {
        username: '',
        password: '',
        confirmPassword: '',
        captcha: ''
      },
      // ---- 校验规则 ----
      loginRules: {
        username: [
          { required: true, validator: validatePhone }
        ],
        password: [
          { required: true, message: '请输入密码' }
        ],
        captcha: [
          { required: true, message: '请输入验证码' }
        ],
        user_type: [
          { required: true, message: '请选择用户类型' }
        ]
      },
      registerRules: {
        username: [
          { required: true, validator: validatePhone }
        ],
        password: [
          { required: true, message: '请输入密码' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword }
        ],
        captcha: [
          { required: true, message: '请输入验证码' }
        ],
        comname: [
          { required: true, message: '请输入公司名称' }
        ],
        comcode: [
          { required: true, message: '请输入统一社会信用代码' }
        ],
        user_type: [
          { required: true, message: '请选择用户类型' }
        ]
      },
      purchaseLoginRules: {
        username: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      purchaseRegisterRules: {
        username: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    // 读取Cookie记住我（销售端）
    if (Cookie.get('checked') === 'true') {
      this.checked = true
      this.loginForm.username = Cookie.get('username') || ''
      this.loginForm.password = Cookie.get('password') || ''
      const savedUserType = Cookie.get('user_type')
      if (savedUserType) {
        this.loginForm.user_type = savedUserType
      }
    }
    this.refreshCaptcha()
  },
  methods: {
    // ---- 通用方法 ----
    // 刷新图形验证码
    async refreshCaptcha () {
      try {
        const res = await captchaRequest.get('https://caixiao.lianglianyn.com/index/get_captcha.php', {
          params: { t: Date.now() }
        })
        const verifyCode = res.headers['x-verify-code'] || res.headers['X-Verify-Code']
        if (verifyCode) {
          this.serverCaptcha = verifyCode
        } else {
          console.warn('未获取到验证码标识')
        }
        const base64 = btoa(
          new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
        )
        this.captchaUrl = `data:image/png;base64,${base64}`
      } catch (error) {
        console.error('获取验证码失败', error)
        this.$message.error('验证码加载失败，请刷新重试')
      }
    },

    forgotPassword () {
      this.$message.info('请联系管理员重置密码')
    },

    // ---- Tab切换 ----
    handleTabClick (tab) {
      // 切换时刷新图形验证码，并清空可能残留的验证码输入
      this.refreshCaptcha()
      if (tab.name === 'sales') {
        this.loginForm.captcha = ''
        this.registerForm.captcha = ''
        this.$refs.loginFormRef && this.$refs.loginFormRef.clearValidate()
        this.$refs.registerFormRef && this.$refs.registerFormRef.clearValidate()
      } else {
        this.purchaseLoginForm.captcha = ''
        this.purchaseRegisterForm.captcha = ''
        this.$refs.purchaseLoginFormRef && this.$refs.purchaseLoginFormRef.clearValidate()
        this.$refs.purchaseRegisterFormRef && this.$refs.purchaseRegisterFormRef.clearValidate()
      }
    },

    // ---- 销售端登录/注册切换 ----
    toggleRegister () {
      this.salesRegister = !this.salesRegister
      this.loginForm.captcha = ''
      this.registerForm.captcha = ''
      this.refreshCaptcha()
      if (this.salesRegister) {
        this.$refs.registerFormRef && this.$refs.registerFormRef.clearValidate()
      } else {
        this.$refs.loginFormRef && this.$refs.loginFormRef.clearValidate()
      }
    },

    // ---- 销售端登录 ----
    handleLogin () {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const response = await apiRequest.post(
            'https://caixiao.lianglianyn.com/index/login.php',
            {
              username: this.loginForm.username,
              password: this.loginForm.password,
              captcha: this.loginForm.captcha,
              ser_captcha: this.serverCaptcha || this.loginForm.captcha,
              user_type: this.loginForm.user_type
            }
          )
          const res = response.data
          if (res.code === 0) {
            if (this.checked) {
              Cookie.set('username', this.loginForm.username, { expires: 7 })
              Cookie.set('password', this.loginForm.password, { expires: 7 })
              Cookie.set('checked', 'true', { expires: 7 })
              Cookie.set('user_type', this.loginForm.user_type, { expires: 7 })
            } else {
              Cookie.remove('username')
              Cookie.remove('password')
              Cookie.remove('checked')
              Cookie.remove('user_type')
            }
            const { token, userid, user_fenlei: userFenlei, work_id: workId, sh_id: shId, jx_id: jxId, brand_id: brandId, comname, comcode } = res.data
            localStorage.setItem('token', token)
            localStorage.setItem('user_name', res.data.username || this.loginForm.username)
            localStorage.setItem('user_type', this.loginForm.user_type)
            Cookie.set('token', token, { expires: 3 })
            if (userid) localStorage.setItem('user_id', userid)
            if (jxId) localStorage.setItem('jx_id', jxId)
            if (shId) { localStorage.setItem('sh_id', shId) } else { localStorage.setItem('sh_id', -1) }
            if (this.loginForm.user_type === 'retailer') localStorage.setItem('jx_id', shId)
            if (brandId) localStorage.setItem('brand_id', brandId)
            if (userFenlei) localStorage.setItem('user_fenlei', userFenlei)
            if (workId) localStorage.setItem('work_id', workId)
            if (comname) localStorage.setItem('comname', comname)
            if (comcode) localStorage.setItem('comcode', comcode)

            this.$message.success('登录成功')
            const redirect = this.$route.query.redirect || '/index'
            this.$router.push(redirect)
          } else {
            this.$message.error(res.msg || '登录失败，请检查账号或验证码')
            this.refreshCaptcha()
            this.loginForm.captcha = ''
          }
        } catch (error) {
          console.error('登录异常', error)
          this.$message.error('网络错误，请稍后重试')
          this.refreshCaptcha()
          this.loginForm.captcha = ''
        } finally {
          this.loading = false
        }
      })
    },

    // ---- 销售端注册 ----
    handleRegister () {
      this.$refs.registerFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const response = await apiRequest.post(
            'https://caixiao.lianglianyn.com/index/register.php',
            {
              a: 'password',
              username: this.registerForm.username,
              password: this.registerForm.password,
              captcha: this.registerForm.captcha,
              ser_captcha: this.serverCaptcha || this.registerForm.captcha,
              comname: this.registerForm.comname,
              comcode: this.registerForm.comcode,
              user_type: this.registerForm.user_type
            }
          )
          const res = response.data
          if (res.code === 0) {
            this.$message.success('注册成功，请登录')
            this.salesRegister = false
            this.loginForm.username = this.registerForm.username
            this.loginForm.password = this.registerForm.password
            this.loginForm.user_type = this.registerForm.user_type
            this.loginForm.captcha = ''
            this.registerForm.captcha = ''
            this.registerForm.confirmPassword = ''
            this.$refs.registerFormRef.resetFields()
            this.$refs.registerFormRef.clearValidate()
            this.refreshCaptcha()
          } else {
            this.$message.error(res.msg || '注册失败，请重试')
            this.refreshCaptcha()
            this.registerForm.captcha = ''
          }
        } catch (error) {
          console.error('注册异常', error)
          this.$message.error('网络错误，请稍后重试')
          this.refreshCaptcha()
          this.registerForm.captcha = ''
        } finally {
          this.loading = false
        }
      })
    },

    // ---- 采购端登录/注册切换 ----
    togglePurchaseRegister () {
      this.purchaseIsRegister = !this.purchaseIsRegister
      this.purchaseLoginForm.captcha = ''
      this.purchaseRegisterForm.captcha = ''
      this.refreshCaptcha()
      if (this.purchaseIsRegister) {
        this.$refs.purchaseRegisterFormRef && this.$refs.purchaseRegisterFormRef.clearValidate()
      } else {
        this.$refs.purchaseLoginFormRef && this.$refs.purchaseLoginFormRef.clearValidate()
      }
    },

    // ---- 采购端登录 ----
    handlePurchaseLogin () {
      this.$refs.purchaseLoginFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const response = await apiRequest.post(
            'https://caixiao.lianglianyn.com/index/login.php',
            {
              a: 'cailogin',
              username: this.purchaseLoginForm.username,
              password: this.purchaseLoginForm.password,
              captcha: this.purchaseLoginForm.captcha,
              ser_captcha: this.serverCaptcha || this.purchaseLoginForm.captcha
            }
          )
          const res = response.data
          if (res.code === 0) {
            const { token, userid, user_fenlei: userFenlei, crm_id: crmId, sh_img: Img, mem_dian: memDian } = res.data
            localStorage.setItem('token', token)
            localStorage.setItem('user_name', res.data.username || this.purchaseLoginForm.username)
            localStorage.setItem('user_type', 'caigou')
            localStorage.setItem('user_phone', this.purchaseLoginForm.username)
            console.log(crmId)
            Cookie.set('token', token, { expires: 3 })
            if (crmId) localStorage.setItem('crm_id', crmId)
            if (userid) localStorage.setItem('user_id', userid)
            if (userFenlei) localStorage.setItem('user_fenlei', userFenlei)
            if (Img) localStorage.setItem('crm_img', Img)
            if (memDian)localStorage.setItem('user_name', memDian)
            this.$message.success('登录成功')

            // const redirect = this.$route.query.redirect || '/eLife/ordercai'
            const redirect = this.$route.query.redirect || '/Shopindex'
            this.$router.push(redirect)
          } else {
            this.$message.error(res.msg || '登录失败，请检查账号或验证码')
            this.refreshCaptcha()
            this.purchaseLoginForm.captcha = ''
          }
        } catch (error) {
          console.error('采购端登录异常', error)
          this.$message.error('网络错误，请稍后重试')
          this.refreshCaptcha()
          this.purchaseLoginForm.captcha = ''
        } finally {
          this.loading = false
        }
      })
    },

    // ---- 采购端注册 ----
    handlePurchaseRegister () {
      this.$refs.purchaseRegisterFormRef.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const response = await apiRequest.post(
            'https://caixiao.lianglianyn.com/index/register.php',
            {
              a: 'caipassword',
              username: this.purchaseRegisterForm.username,
              password: this.purchaseRegisterForm.password,
              captcha: this.purchaseRegisterForm.captcha,
              ser_captcha: this.serverCaptcha || this.purchaseRegisterForm.captcha
            }
          )
          const res = response.data
          if (res.code === 0) {
            this.$message.success('注册成功，请登录')
            this.purchaseIsRegister = false
            this.purchaseLoginForm.username = this.purchaseRegisterForm.username
            this.purchaseLoginForm.password = this.purchaseRegisterForm.password
            this.purchaseLoginForm.captcha = ''
            this.purchaseRegisterForm.captcha = ''
            this.purchaseRegisterForm.confirmPassword = ''
            this.$refs.purchaseRegisterFormRef.resetFields()
            this.$refs.purchaseRegisterFormRef.clearValidate()
            this.refreshCaptcha()
          } else {
            this.$message.error(res.msg || '注册失败，请重试')
            this.refreshCaptcha()
            this.purchaseRegisterForm.captcha = ''
          }
        } catch (error) {
          console.error('采购端注册异常', error)
          this.$message.error('网络错误，请稍后重试')
          this.refreshCaptcha()
          this.purchaseRegisterForm.captcha = ''
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  height: 100%;
  background: url("https://lianglianyn.com/xfdx/image/one/01.jpg") no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.content {
  border-radius: 6px;
  background: rgba(255,255,255,0.95);
  width: 460px;
  padding: 30px 30px 20px 30px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  h3 {
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
    color: red;
  }
}
.el-form-item {
  margin-top: 20px;
}
.el-button--primary {
  width: 100%;
  margin-bottom: 10px;
}
.captcha-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  .captcha-input {
    flex: 1;
  }
  .captcha-image {
    height: 40px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f7fa;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.bottom-links {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  .link {
    color: #409eff;
    cursor: pointer;
    font-size: 14px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
